export const css = {
	root: '_3b156iNi',
	question: '_1MN9oXWm',
	feedback: '_3_d3vc5p',
	rationale: '_37Jc9-nV',
	fmi: 'Hi-LeuYd',
	distractorBlock: '_23_3-P7T',
	distractorFieldset: '_1aWtixW_',
	distractorLegend: '_3YGfUbr0',
	distractor: 'nIdJNV-T',
	distractorLabel: '_1yfc80BO',
	distractorWithFlag: 'csYUpDDn',
	distractorHint: 'D-1CCFOM',
	actions: '_2yxSbbGu',
	oneaction: '_1Bh1rzrp',
	markblock: '_1d1J7Aus',
	timerblock: 'ALQp7ukO',
	timer: '_3KuY8r5r',
	' _key': 'ascm-theme/ascm/quiz-widgets/mcquestion'
};

export default css;
